import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
const screenfull = require('screenfull');
const browser = require('jquery.browser');
declare var $: any;

import { SettingsService } from '../../core/settings/settings.service';
import { MenuService } from '../../core/menu/menu.service';
import { UserService, CommonService,DomainService } from '../../shared/services';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

    navCollapsed = true; // for horizontal layout
    menuItems = []; // for horizontal layout
    user: any;
    notifs: any;
    isNavSearchVisible: boolean;
    logo: string;
    frontDomainName: string;
    @ViewChild('fsbutton') fsbutton;  // the fullscreen button

    constructor(
        private router: Router,
        public menu: MenuService,
        public settings: SettingsService,
        private userService: UserService,
        private commonService: CommonService,
        private domainService: DomainService

    ) {
         this.logo = this.domainService.getFrontendLogo();
         this.frontDomainName = this.domainService.getFrontendDomainName();
        // show only a few items on demo
        this.menuItems = menu.getMenu().slice(0, 4); // for horizontal layout
        this.user = {
            data: this.userService.getData(),
            company: this.userService.getCompany(),
            companies: this.userService.getCompanies()
        };

        this.commonService.getNotifs().subscribe(data => {
            this.notifs = data;
        });
    }

    ngOnInit() {
        if (browser.msie) { // Not supported under IE
            this.fsbutton.nativeElement.style.display = 'none';
        }
    }

    toggleOffsidebar() {
        this.settings.layout.offsidebarOpen = !this.settings.layout.offsidebarOpen;
    }

    toggleCollapsedSideabar() {
        this.settings.layout.isCollapsed = !this.settings.layout.isCollapsed;
    }

    isCollapsedText() {
        return this.settings.layout.isCollapsedText;
    }

    toggleFullScreen(event) {

        if (screenfull.enabled) {
            screenfull.toggle();
        }
        // Switch icon indicator
        const el = $(this.fsbutton.nativeElement);
        if (screenfull.isFullscreen) {
            el.children('em').removeClass('fa-expand').addClass('fa-compress');
        }
        else {
            el.children('em').removeClass('fa-compress').addClass('fa-expand');
        }
    }

    lockUser() {
        this.router.navigate(['/lock']);
    }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/layout/header/header.component.ts